export const API_URL = process.env.REACT_APP_API_URL
export const GOOGLE_RECAPTCHA_KEY = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY
export const PLAID_PUBLIC_KEY = process.env.REACT_APP_PLAID_PUBLIC_KEY
